var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.376 12.453a6.013 6.013 0 0 0 7.413-7.414A5.946 5.946 0 0 0 12.63.88a6.013 6.013 0 0 0-7.413 7.414 5.947 5.947 0 0 0 4.16 4.16Zm1.627 1.546A10.667 10.667 0 0 0 .336 24.666a2.667 2.667 0 0 0 2.667 2.667h16a2.667 2.667 0 0 0 2.666-2.667A10.667 10.667 0 0 0 11.003 14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.d163e7ee4c3c89be563d68fb0b3b4fd9.svg";
export { ForwardRef as ReactComponent };